import React, { useCallback, useEffect, useRef, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import { Grid } from '@mui/material';
// import TextInput from '../Input/TextInput';
import { useTranslation } from 'react-i18next';
import { sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import ButtonAction from 'src/components/Button.js/SaveButton';
import ComboBox from 'src/components/Input/ComboBox';
import Loader from 'src/components/loader/loader';
import TextInput from 'src/components/Input/TextInput';
import ConfirmModal from 'src/components/modal/ConfirmModal';
import crypt from 'src/utils/service/crypt';
import NotificationHikvisionModal from 'src/components/modal/NotificationHikvisionModal';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const RegisterCardNoModal = ({ visible = false, dataUpdate, setVisible, fuctGet, idPermission }) => {
    const { t } = useTranslation();
    const [flagAddStat, setFlagAddStat] = useState(false);
    const addFlag = React.useRef(false);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const [cardNo, setCardNo] = useState();

    const [isSubmit, setIsSubmit] = useState(false);

    const [visibleDel, setVisibleDel] = useState(false);
    const delFlags = useRef(false);
    const [deleteFlags, setDeleteFlags] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [loading, setLoading] = useState(false);

    const [visibleNotification, setVisibleNotification] = useState(false);
    const [dataNotification, setDataNotification] = useState([]);

    const menu = sessionStorage.getItem('menu');
    let screenPermissions = {};

    if (menu) {
        try {
            const data = JSON.parse(crypt.deCode(menu));
            // console.log('Loading menu', data[0]);
            screenPermissions = data[0].filter((item) => item.screens_key === 'ds_nv')[0];
            // console.log('screenPermissions', screenPermissions);
        } catch (error) {}
    }
    // const optionCardType = [
    //     {
    //         label:  t('Normal Card'),
    //         value: "normalCard",
    //     },
    //     {
    //         label:  t('Patrol Card'),
    //         value: "patrolCard",
    //     },
    //     {
    //         label:  t('Duress Card'),
    //         value: "hijackCard",
    //     },
    //     {
    //         label:  t('Super Card'),
    //         value: "superCard"
    //     },
    //     {
    //         label:  t('Dismiss Card'),
    //         value: "dismissingCard",
    //     },
    //     {
    //         label: t('Emergency Card'),
    //         value: "emergencyCard"
    //     },
    // ];
    // const [valueOption, setValueOption] = useState({
    //     label:  t('Normal Card'),
    //     value: "normalCard",
    // });
    useEffect(() => {
        if (dataUpdate) {
            setCardNo(dataUpdate?.card_no);
        } else {
            setCardNo();
        }
    }, [dataUpdate, visible]);

    const handleSubmit = () => {
        setIsSubmit(true);
        if (addFlag.current === true) return;
        if (!cardNo) return toast.error(t('error.param'));

        addFlag.current = true;
        setFlagAddStat(true);

        let InVal = [dataUpdate.id, cardNo];
        sendRequest(serviceList.registerCardNo, InVal, actionResult, true, timeOutFunct, 40000);
    };
    const actionResult = (reqInfoMap, message) => {
        addFlag.current = false;
        setFlagAddStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            // console.log("RegisterCardError", message, message.proc_data.rows[0].o_1);
            if (message['proc_code'] !== 'HRM017') {
                setDataNotification(message.proc_data.rows[0].o_1);
                setVisibleNotification(true);
            }
            setIsSubmit(false);
            return;
        } else {
            // console.log("RegisterCardSuccess", message, message.proc_data.rows[0].o_1);
            if (message['proc_code'] === 'HRM026') {
                toast.warning(message['proc_message']);
            } else {
                toast.success(message['proc_message']);
            }
            setDataNotification(message.proc_data.rows[0].o_1);
            setVisibleNotification(true);
            // fuctGet && fuctGet();
            // setVisible(!visible);
            setIsSubmit(false);
        }
    };
    const timeOutFunct = (reqInfo) => {
        addFlag.current = false;
        setFlagAddStat(false);
        setIsSubmit(false);
        toast.error(t('error.time_out'));
    };

    const handleDelete = () => {
        if (!dataUpdate.id) return toast.error(t('error.system_error'));
        if (delFlags.current) {
            return;
        }
        setDeleteFlags(true);
        delFlags.current = true;
        const InVal = [dataUpdate.id, cardNo];
        sendRequest(serviceList.deleteCardNo, InVal, deleteResult, true, timeOutFunctDel, 40000);
    };

    const deleteResult = (reqInfoMap, message) => {
        setDeleteFlags(false);
        delFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            // console.log("DeleteCardError", message, message.proc_data.rows[0].o_1);
            setDataNotification(message.proc_data.rows[0].o_1);
            setVisibleDel(false);
            setIsDelete(true);
            setVisibleNotification(true);
            return;
        } else {
            if (message['proc_code'] === 'HRM026') {
                toast.warning(message['proc_message']);
            } else {
                toast.success(message['proc_message']);
            }
            setDataNotification(message.proc_data.rows[0].o_1);
            setVisibleDel(false);
            setIsDelete(true);
            setVisibleNotification(true);
            // fuctGet && fuctGet();
            // setVisible(!visible);
        }
    };

    const timeOutFunctDel = (reqInfo) => {
        setDeleteFlags(false);
        delFlags.current = false;
        toast.error(t('error.time_out'));
    };

    const handleClose = () => {
        setVisible(!visible);
        setIsSubmit(false);
        // fuctGet && fuctGet();
        // if (dataUpdate?.cardNo) {
        //     setCardNo(dataUpdate?.card_no)
        // } else {
        //     setCardNo('')
        // }
    };

    return (
        <BootstrapDialog
            // style={{ width: '50%' }}
            fullScreen={fullScreen}
            open={visible}
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
        >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                {t('register_card_no')}
            </BootstrapDialogTitle>
            <Loader loading={flagAddStat} />
            <ConfirmModal
                loading={deleteFlags}
                visible={visibleDel}
                setVisible={setVisibleDel}
                handleDelete={handleDelete}
            />
            <NotificationHikvisionModal
                type={'cardNo'}
                visibleNotification={visibleNotification}
                setVisibleNotification={setVisibleNotification}
                visibleRegister={visible}
                setVisibleRegister={setVisible}
                dataNotification={dataNotification}
                fuctGet={fuctGet}
                isDelete={isDelete}
                setIsDelete={setIsDelete}
            />
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                        <TextInput label={t('code_staff')} valueChange={dataUpdate.id} disabled />
                    </Grid>
                    <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                        <TextInput label={t('name_staff')} valueChange={dataUpdate.user_nm} disabled />
                    </Grid>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <TextInput
                            label={t('Card No')}
                            valueChange={cardNo}
                            getValue={setCardNo}
                            required
                            error={!cardNo && isSubmit}
                            helperText={!cardNo && isSubmit ? t('required_input') : ''}
                        />
                    </Grid>
                    {/* <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <ComboBox
                            label={t('Card type')}
                            valueSelect={valueOption}
                            required
                            getValue={setValueOption}
                            selectOption={optionCardType}
                        />
                    </Grid> */}
                </Grid>
            </DialogContent>
            <DialogActions>
                <ButtonAction onClick={handleClose} type={'cancel'} title={t('cancel')} />
                {screenPermissions?.delete_permission === '1' && dataUpdate.card_no && (
                    <ButtonAction title={t('delete')} type="delete" onClick={() => setVisibleDel(true)} />
                )}
                {screenPermissions?.update_permission === '1' && dataUpdate.card_no ? (
                    <ButtonAction onClick={handleSubmit} type={'update'} title={t('update')} />
                ) : (
                    screenPermissions?.insert_permission === '1' && (
                        <ButtonAction onClick={handleSubmit} type={'save'} title={t('save')} />
                    )
                )}
            </DialogActions>
        </BootstrapDialog>
    );
};

export default RegisterCardNoModal;
